{
	"appName": "Cleanbudget",
	"admin": "Beheer",
	"menu": "Menu",
	"openMenu": "Menu openen",
	"closeMenu": "Menu sluiten",
	"signOut": "Uitloggen",
	"signedInAs": "Ingelogd als {{name}}",
	"never": "Nog nooit",
	"close": "Sluiten",
	"undo": "Ongedaan maken",
	"more": "Meer",
	"table": {
		"search": "Zoeken…",
		"all": "Alle",
		"noMatches": "Niets gevonden met deze zoekopdracht of filters.",
		"clearFilters": "Zoekopdracht en filters wissen",
		"pastEnd": "Deze pagina bestaat niet (meer).",
		"firstPage": "Naar de eerste pagina",
		"pagination": "Pagina's",
		"range": "{{from}}–{{to}} van {{total}}",
		"pageOf": "Pagina {{page}} van {{pages}}",
		"pageSize": "Per pagina",
		"previous": "Vorige pagina",
		"next": "Volgende pagina"
	},
	"form": {
		"saving": "Bezig met opslaan…",
		"failed": "Opslaan lukte niet. Probeer het opnieuw.",
		"saved": "Opgeslagen"
	},
	"validation": {
		"required": "Vul dit in.",
		"tooShort_one": "Gebruik minstens {{count}} teken.",
		"tooShort_other": "Gebruik minstens {{count}} tekens.",
		"tooLong_one": "Gebruik hoogstens {{count}} teken.",
		"tooLong_other": "Gebruik hoogstens {{count}} tekens.",
		"tooSmall": "Vul {{minimum}} of meer in.",
		"tooBig": "Vul {{maximum}} of minder in.",
		"email": "Vul een geldig e-mailadres in.",
		"url": "Vul een geldig webadres in.",
		"number": "Vul een getal in.",
		"choice": "Kies een van de opties.",
		"money": "Vul een bedrag in, zoals 4,99.",
		"code": "Gebruik alleen letters, cijfers, - en _.",
		"endsBeforeStart": "Het einde moet na het begin liggen.",
		"dateTime": "Vul een datum en tijd in.",
		"percent": "Vul een heel getal van 1 tot 100 in.",
		"positiveNumber": "Vul een heel getal van 1 of meer in.",
		"invalid": "Dit klopt niet.",
		"days": "Vul een heel getal van 1 tot 365 in."
	},
	"notFound": {
		"title": "Pagina niet gevonden",
		"description": "Deze pagina bestaat niet (meer).",
		"back": "Naar de startpagina"
	},
	"error": {
		"title": "Er ging iets mis",
		"retry": "Opnieuw proberen"
	},
	"confirm": {
		"cancel": "Annuleren",
		"failed": "Dat lukte niet. Probeer het opnieuw."
	},
	"published": {
		"label": "Gepubliceerd",
		"yes": "Gepubliceerd",
		"no": "Concept"
	},
	"helpPanel": {
		"help": "Help",
		"helpFor": "Uitleg over {{title}}",
		"close": "Help sluiten",
		"back": "Terug",
		"search": "Zoek in de help",
		"searchPlaceholder": "Zoek, bijv. staffel of klantgroep",
		"noResults": "Niets gevonden.",
		"allTopics": "Alle uitleg",
		"choices": "Je kiest uit",
		"howTo": "Zo stel je het in",
		"inShop": "Zo ziet het eruit in de shop",
		"warning": "Let op",
		"related": "Zie ook",
		"pause": "Pauze",
		"play": "Afspelen",
		"replay": "Opnieuw"
	}
}
